
import { mapState } from 'vuex'

export default {
  props: ['error'],
  computed: {
    ...mapState('session', ['user'])
  },
  mounted () {
    if (this.error.statusCode === 401) this.$store.dispatch('session/login')
    if (!this.user && this.error.statusCode === 403) this.$store.dispatch('session/login')
  }
}
